module.exports = __webpack_public_path__ + "static/media/Sylas_0.39993795.jpg";